// extracted by mini-css-extract-plugin
module.exports = {"StepIcon":"StepIcon_StepIcon__wHbhD","completed":"StepIcon_completed__1KYpP"};